import React, { Component } from 'react';
import {
  BackHandler,
  View,
} from 'react-native';
import { translate } from 'react-i18next';

import { getUrls } from '../config';
import { WebView } from '../ui/components';
import { UserDataConsumer } from '../utils';
import { GoogleAnalytics } from '../services/google-analytics';
import { Logger } from '../utils/Logger';

class FaqScreen extends Component {
  googleAnalytics = new GoogleAnalytics();

  constructor(props) {
    super(props);
    this.state = {
      isOnDetailsPage: false,
      isLoading: true,
    };
    this.props.navigation.backReplacement = this.backReplacement.bind(this);
  }

  render() {
    const { FAQ_PAGE } = getUrls();

    return (
      <View style={{ flex: 1, justifyContent: 'center' }}>
      <WebView
          javaScriptEnabled
          onMessage={() => { /* no-op */ }}
          useWebKit={true}
          source={{ uri: FAQ_PAGE }}
          style={{ flex: 1 }}
          onNavigationStateChange={this.onWebViewNavigationStateChange.bind(this)}
          ref={'faqWebView'}
          startInLoadingState
        />
      </View>
    );
  }

  componentDidMount() {
    this.googleAnalytics.setCurrentScreen('FaqScreen');
    this.backHandler = BackHandler.addEventListener('hardwareBackPress', () => {
      return this.backReplacement();
    });
  }

  componentWillUnmount() {
    this.backHandler.remove();
    delete this.props.navigation.backReplacement;
  }

  onWebViewNavigationStateChange(navState) {
    const isOnDetailsPage = navState.url.match('/faq/.+/.+.html');
    this.setState({
      isOnDetailsPage: isOnDetailsPage ? navState.url : undefined,
      isLoading: navState.loading,
    });
  }

  backReplacement() {
    if (this.state.isOnDetailsPage) {
      Logger.debug('[faq] is on details page, going back in web view', this.state.isOnDetailsPage);
      this.refs.faqWebView.goBack();
      return true;
    }
    return false;
  }
}

const FaqScreenConsumer = UserDataConsumer(FaqScreen);
export default translate(['home'], { wait: true })(FaqScreenConsumer);
